export default {
    wallet: 'Wallet',
    balance: 'balance',
    wallet_transaction: 'Wallet transaction',
    top_up: 'Top-up',
    withdraw: 'Withdraw',
    withdraw_refund: 'Withdraw Refund',
    invoice: 'Invoice',
    invoice_refund: 'Invoice refund',
    manual_refund: 'Manual refund',
    sms_service: 'SMS service',
    id: 'ID',
    time: 'Time',
    type: 'Type',
    amount: 'Amount',
    action: 'ACTION',
    detail: 'Detail',
    amount_from: 'Amount from',
    status: 'Status',
    pending: 'Pending',
    processing: 'Processing',
    paid: 'Paid',
    complete: 'Complete',
    cancelled: 'Cancelled',
    account_balance: 'Account Balance',
    method: 'Payment',
    manual_refund_detail: 'Manual Refund Detail',
    payments: 'Payments',
    wallet_detail: 'Top-up Detail',
};
